enum DocumentRequirementStatus {
  OPTIONAL
  DISABLED
  REQUIRED
}

type AutoSatisfy {
  document_types: [DocumentKind]
  count: Int
  broker_verification_required: Boolean
  satisfied_document_ids: [String!]
}

type DocumentRequirementDetails {
  organisation_id: ID
  name: String
  description: String
  status: DocumentRequirementStatus
  gi: Boolean
  protection_types: [ProtectionProductType]
  case_types: [MortgageReason]
  document_types: [DocumentKind]
  auto_satisfy: [AutoSatisfy]
  default_overdue: Int
  per_client: Boolean
  can_share_with_client: Boolean
  required_from: CaseStatus
  required_by: CaseStatus
  apply_to_existing: Boolean
  exclude_product_transfer: Boolean
  exclude_renewal: Boolean
  exclude_no_contact_renewal: Boolean
}

type DocumentRequirement {
  requirement_id: ID!
  created_at: String
  created_by: String
  modified_at: String
  disabled_at: String
  details: DocumentRequirementDetails
}

input AutoSatisfyInput {
  document_types: [DocumentKind]
  count: Int
  broker_verification_required: Boolean
}

input DocumentRequirementDetailsInput {
  organisation_id: ID
  name: String
  description: String
  status: DocumentRequirementStatus
  gi: Boolean
  protection_types: [ProtectionProductType]
  case_types: [MortgageReason]
  document_types: [DocumentKind]
  auto_satisfy: [AutoSatisfyInput]
  default_overdue: Int
  per_client: Boolean
  can_share_with_client: Boolean
  required_from: CaseStatus
  required_by: CaseStatus
  apply_to_existing: Boolean
  exclude_product_transfer: Boolean
  exclude_renewal: Boolean
  exclude_no_contact_renewal: Boolean
}

input DocumentRequirementInput {
  requirement_id: ID
  created_at: String
  created_by: String
  modified_at: String
  disabled_at: String
  details: DocumentRequirementDetailsInput
}
